/**
 * Product Card A/B Test Helper
 *
 * Image swapping is now handled purely by CSS via the `body.variation-1` class.
 * This helper stays in place for backwards compatibility and to support
 * experimentation tools that need to toggle the variation globally.
 */

class ProductCardABTest {
  static switchImage() {
    console.warn('[ProductCardABTest] switchImage is deprecated. Toggle the body class "variation-1" instead.');
  }

  static switchAllImages(useTestImage = true) {
    if (!document.body) {
      return;
    }

    document.body.classList.toggle('variation-1', Boolean(useTestImage));
  }

  static switchImageByHandle(handle, useTestImage = true) {
    console.warn(`[ProductCardABTest] switchImageByHandle("${handle}") is deprecated. Toggling the body class instead.`);
    this.switchAllImages(useTestImage);
  }

  static applyRandomTest(percentage = 50) {
    if (percentage <= 0) {
      this.switchAllImages(false);
      return;
    }

    if (percentage >= 100) {
      this.switchAllImages(true);
      return;
    }

    console.warn('[ProductCardABTest] applyRandomTest is no longer supported. Use your experimentation tool to manage visitor bucketing and toggle the "variation-1" body class per visitor.');
  }
}

window.ProductCardABTest = ProductCardABTest;

if (window.ab_test_control === true) {
  const enableVariation = () => ProductCardABTest.switchAllImages(true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableVariation, { once: true });
  } else {
    enableVariation();
  }
}

